import {isNil} from 'ramda';

import {
  GetServiceOrderBulkPrintDocumentsRestrictionsApiResponse,
  PostServiceOrderBulkPrintDocumentsApiResponse,
} from '@dms/api/workshop';

type BulkPrintDocumentRestriction =
  | GetServiceOrderBulkPrintDocumentsRestrictionsApiResponse[number]['restriction']
  | PostServiceOrderBulkPrintDocumentsApiResponse[number]['restriction'];

export function getBulkPrintDocumentRestrictionMessage(
  restriction: BulkPrintDocumentRestriction
): string[] | undefined {
  if (isNil(restriction)) {
    return undefined;
  }
  const normalizedRestrictions = Array.isArray(restriction) ? restriction : [restriction];
  const messages: string[] = [];

  for (const item of normalizedRestrictions) {
    const message = item?.message;

    if (!isNil(message)) {
      messages.push(message);
    }
  }

  return messages.length > 0 ? messages : undefined;
}
